<template>
	<div class="loader">
		<span class="loader-element"></span>
		<span class="loader-element"></span>
		<span class="loader-element"></span>
	</div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.loader {
	display: flex;
	align-items: center;
	justify-content: center;
	@include flex-start;
}

.loader-element {
	border-radius: 100%;
	border: 2px solid var(--border-brand);
	margin: 4px;
}

.loader-element:nth-child(1) {
	animation: preloader 0.6s ease-in-out alternate infinite;
}
.loader-element:nth-child(2) {
	animation: preloader 0.6s ease-in-out alternate 0.2s infinite;
}

.loader-element:nth-child(3) {
	animation: preloader 0.6s ease-in-out alternate 0.4s infinite;
}

@keyframes preloader {
	100% {
		transform: scale(2);
	}
}
</style>
